<template>
  <div class="shopcardet content_center">
    <div class="mtb20 ft12 C787878">
      <span>您现在的位置：</span>
      <span>
        <a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a>
      </span>
      <span class="el-icon-arrow-right"></span>
      <span>商品详情</span>
    </div>
    <div class="flex justify_content_between shopcardet_box">
      <div class="shopcardet_img">
        <div class="box">
          <pic-zoom :url="imgurl" :scale="3"></pic-zoom>
        </div>
        <div class="list">
          <ul>
            <li
              v-for="(item, index) in goods.pictureList"
              :key="index"
              @mouseenter="changeImage(item.urlAddress)"
            >
              <el-image :src="item.urlAddress" />
            </li>
          </ul>
        </div>
      </div>
      <div class="shopcardet_price">
        <p class="title">{{ goods.productName }}</p>
        <div class="addprice">
          <div class="price flex">
            <p class="addprice1">单价</p>
            <p class="addprice2 E5433D">
              <span>￥</span>
              {{ goods.price ? goods.price : '0' }}
            </p>
          </div>
          <template v-if="promotion.length">
            <div class="sell">
              <div class="sell1">促销</div>
              <!-- <div class="sell2" :style="'background:'+theme">促销</div> -->
              <div>
                <div v-for="(item, index) in promotion" :key="index" class="sell-item">
                  <div class="sell3" :style="'color:' + theme">{{ item.name }}</div>
                  <div class="sell-info">{{ item.description }}</div>
                  <div class="sell-info">有效期：{{ item.time }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="addnum">
          <span>数量</span>
          <el-input-number
            size="small"
            v-model="nums"
            :min="1"
            :max="10"
            label="描述文字"
          ></el-input-number>
          <span>{{ goods.saleUnitName }}</span>
        </div>
        <div class="addshop flex">
          <div @click="goshopproduct" class="addshop1 border_them E5433D flex flexalignitem_center">
            <img width="18" height="18" src="@/assets/img/buyNow.svg" />
            &nbsp;立即购买
          </div>
          <div class="addshop2 bgE5433D ml10 flex flexalignitem_center" @click="addshopcar(goods)">
            <img width="18px" height="18px" src="@/assets/img/addShopCar.svg" alt="" />
            &nbsp;加入购物车
          </div>
          <div class="addshop3">
            <img
              :src="goods.ofenFlag ? collectactive : collectionImg"
              @click="collectionImgs(goods)"
              alt=""
            />
            <span>加入收藏夹</span>
          </div>
        </div>
      </div>
    </div>
    <div class="shopcardet_imgs">
      <p class="protitle">商品介绍</p>
      <div class="shopcardetimg_box" v-if="goods.pictureList">
        <p v-for="(item, index) in goods.pictureList" :key="index">
          <img :src="item.urlAddress ? item.urlAddress : noPic" alt="" />
        </p>
      </div>
      <div v-else class="noData">
        无商品介绍
      </div>
    </div>
    <!-- <div class="shopcardet_imgs">
            <p class="protitle">商品描述</p>
            <div class="shopcardetimg_box" v-if="goods.introductionVo.introductionText" v-html="goods.introductionVo.introductionText">
              
            </div>
            <div v-else  class="noData">
                无商品描述
            </div>
        </div> -->
    <!-- <div class="shopcardet_imgs">
            <p class="protitle">促销活动简介</p>
            <div class="shopcardetimg_box" v-if="goods.introductionVo.introductionText" v-html="goods.introductionVo.introductionText">
              
            </div>
            <div v-else  class="noData">
                无促销活动简介
            </div>
        </div> -->
  </div>
</template>
<script>
/**
 * @description: 方法
 * @param {*} PicZoom 放大镜插件
 * @param {*}  collectactive  收藏图片
 * @param {*}  collectionImg  取消收藏图片
 * @param {*}  FindGoodsDetailAndPromotionByCode  商品详情接口
 * @param {*}  OfenByfictitiousIds    收藏接口
 * @param {*}  reMoveOfenByfictitiousIds 取消接口
 * @param {*}  ShoppingCart 加入购物车接口
 * @author: txp
 */
import PicZoom from 'vue-piczoom'
import collectionImg from '@/assets/img/collectionImgs.svg'
import collectactive from '@/assets/img/collectactives.svg'
import { Storage } from '@/utils/storage'
import { mapGetters } from 'vuex'
import {
  FindGoodsDetailAndPromotionByCode,
  OfenByfictitiousIds,
  reMoveOfenByfictitiousIds,
  ShoppingCart
} from '@/api/api'
import noPic from '@/assets/img/no_goods.png'
export default {
  name: 'shopcardet',
  data() {
    return {
      nums: 1,
      collectionImg,
      collectactive,
      shopcardetList: {},
      goods: {},
      promotion: [],
      imgurl: '',
      noPic
    }
  },
  components: {
    PicZoom
  },
  computed: {
    ...mapGetters({
      theme: 'theme'
    })
  },
  created() {
    this.shopcardetLists(this.$route.query.productCode)
  },
  methods: {
    /**
     * @description:  获取详情信息
     * @param {string}  goodsCode 商品编码
     * @return  {goods,promotion} good表示商品列表 promotion 表示促销详情活动
     * @author: txp
     */

    shopcardetLists(goodsCode) {
      FindGoodsDetailAndPromotionByCode(goodsCode).then((res) => {
        if (res.code === 200) {
          this.shopcardetList = res.result
          this.goods = res.result.goods
          this.goods.pictureList = this.goods.pictureList ? JSON.parse(this.goods.pictureList) : []
          this.goods.introductionVo = JSON.parse(this.goods.introductionVo) || {}
          this.imgurl = this.goods.pictureList.length ? this.goods.pictureList[0].urlAddress : ''
          if (res.result.promotion && res.result.promotion.length > 0) {
            let promotion = res.result.promotion
            let promotionRule = []
            for (let i = 0; i < promotion.length; i++) {
              //这里默认只要有第一层就会显示第二层的促销政策
              for (let j = 0; j < promotion[i].promotions.length; j++) {
                // 这层是取所有的政策
                promotionRule.push({
                  name: promotion[i].promotions[j].promotionPolicyName,
                  description: promotion[i].promotions[j].description,
                  time: `${promotion[i].promotions[j].beginTime} 至 ${promotion[i].promotions[j].endTime}`
                })
              }
            }
            this.promotion = promotionRule
          }
        }
      })
    },
    /**
     * @description:  点击切换收藏
     * @param {*} ofenFlag 1 代表收藏  0代表未收藏
     * @author: txp
     */
    collectionImgs(goods) {
      if (goods.ofenFlag != 1) {
        OfenByfictitiousIds([goods.id]).then((res) => {
          if (res.code == 200) {
            goods.ofenFlag = 1
            this.$message.success('收藏成功')
          }
        })
      } else {
        reMoveOfenByfictitiousIds([goods.id]).then((res) => {
          if (res.code == 200) {
            goods.ofenFlag = 0
            this.$message.warning('取消收藏')
          }
        })
      }
    },
    /**
     * @description: 加入购物车
     * @param {string}  productCode 此类商品编码
     * @param {string}  productName 此类商品名称
     * @param {num}  num 加入购物车数量
     * @return {*}
     * @author: txp
     */
    addshopcar(goods) {
      let { productCode, productName } = goods
      ShoppingCart({
        goodsCode: productCode,
        goodsName: productName,
        num: this.nums
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
        }
      })
    },
    // 放大镜图片切换显示
    changeImage: function(url) {
      this.imgurl = url
    },
    // 立即购买
    goshopproduct() {
      const dataList = []
      let lists = this.shopcardetList.goods
      console.log(lists.pictureList)
      let obj = {
        ...lists,
        productNum: this.nums, //根据获取的购物车中加购的数量
        isChecked: true,
        lineType: '10',
        imgUrl: lists.pictureList.length ? lists.pictureList[0].urlAddress : ''
      }
      dataList.push(obj)
      Storage.l.set('orderList', JSON.stringify(dataList))
      this.$router.push({
        path: '/home/shopsesttle'
      })
    },
    // 返回上一页
    goHomes() {
      window.history.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.noData {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: rgb(153, 153, 153);
  line-height: 100px;
}
.shopcardet {
  .shopcardet_link {
    a {
      color: #409eff; //主题色
    }
  }
  .shopcardet_box {
    .shopcardet_img {
      margin-right: 40px;
      width: 448px;
      .box {
        height: 448px;
        border: 1px solid #d8d8d8;
        box-sizing: content-box;
        border-radius: 2px;
      }
      .list {
        margin-top: 15px;
        ul {
          display: flex;
          justify-content: flex-start;
          li {
            width: 78px;
            height: 78px;
            border: 1px solid #d8d8d8;
            padding: 1px;
            box-sizing: content-box;
            margin-right: 12px;
            /deep/.el-image__inner {
              width: 78px;
              height: 78px;
            }
          }
          li:hover {
            border: 1px solid #409eff; //主题色
            box-sizing: content-box;
          }
        }
      }
    }

    .shopcardet_price {
      flex: 1;
      .title {
        font-size: 24px;
        color: #1d1d1d;
      }
      .addprice {
        background: rgb(241, 241, 241);
        padding: 22px 12px;
        margin: 50px 0px 20px;
        .price {
          .addprice1 {
            font-size: 12px;
            color: #787878;
            line-height: 30px;
          }
          .addprice2 {
            margin-left: 30px;
            font-size: 30px;
            line-height: 30px;
            span {
              font-size: 12px;
            }
          }
        }
        .sell {
          margin-top: 34px;
          display: flex;
          align-items: flex-start;
          .sell-item {
            margin-bottom: 10px;
          }
          .sell1 {
            font-size: 12px;
            color: #787878;
          }
          .sell2 {
            margin-left: 30px;
            display: inline-block;
            color: #ffffff;
            font-size: 12px;
            border-radius: 2px;
            padding: 1px 5px;
          }
          .sell3 {
            width: 100px;
            border: 1px solid $color-primary;
            margin-left: 20px;
            padding: 2px 5px;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 6px;
          }
          .sell-info {
            font-size: 12px;
            color: rgb(143, 143, 143);
            line-height: 20px;
            margin-left: 20px;
            padding: 2px 0;
          }
        }
      }
      .addshop {
        margin-top: 120px;
        .addshop1 {
          width: 120px;
          border-radius: 2px;
          margin-right: 20px;
          font-size: 16px;
          justify-content: center;
          cursor: pointer;
        }
        .addshop2 {
          width: 120px;
          border-radius: 2px;
          margin-right: 20px;
          font-size: 16px;
          color: #ffffff;
          cursor: pointer;
          justify-content: center;
        }
        .addshop3 {
          cursor: pointer;
          padding: 10px 20px;
          border-radius: 2px;
          font-size: 16px;
          color: #787878;
          vertical-align: middle;
          img {
            vertical-align: middle;
            margin-right: 5px;
          }
        }
      }
      .addnum {
        span {
          font-size: 14px;
          color: #787878;
          letter-spacing: 0;
          margin-left: 10px;
          margin-right: 20px;
        }
      }
    }
  }
  .shopcardet_imgs {
    margin-top: 40px;
    .protitle {
      background: #f7f7f8;
      padding: 10px;
      font-size: 16px;
      color: #4c4747;
    }
    .shopcardetimg_box {
      text-align: center;
      p {
        margin: 20px 0px;
        img {
          max-width: 750px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
